import { useState } from "react";

import { Dialog, useMediaQuery, useTheme } from "@mui/material";

import NewTicketForm from "components/support/NewTicketForm";
import TicketDetail from "components/support/TicketDetail";
import TicketList from "components/support/TicketList";

type View = { kind: "list" } | { kind: "detail"; id: number } | { kind: "new" };

const LIST_VIEW: View = { kind: "list" };

interface TicketsDialogProps {
  open: boolean;
  onClose: () => void;
}

const TicketsDialog = ({ open, onClose }: TicketsDialogProps) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [view, setView] = useState<View>(LIST_VIEW);
  // Kept here rather than in the list so returning from a ticket lands on the
  // page it was opened from.
  const [page, setPage] = useState(1);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      fullScreen={fullScreen}
      // Reset once the close animation ends, so the next open starts on the
      // list without the content jumping while it fades out.
      TransitionProps={{
        onExited: () => {
          setView(LIST_VIEW);
          setPage(1);
        },
      }}
    >
      {view.kind === "list" && (
        <TicketList
          page={page}
          onPageChange={setPage}
          onOpen={(id) => setView({ kind: "detail", id })}
          onNew={() => setView({ kind: "new" })}
          onClose={onClose}
        />
      )}
      {view.kind === "detail" && (
        <TicketDetail
          id={view.id}
          onBack={() => setView(LIST_VIEW)}
          onClose={onClose}
        />
      )}
      {view.kind === "new" && (
        <NewTicketForm
          onCancel={() => setView(LIST_VIEW)}
          onCreated={(id) => {
            // The new ticket is the newest, so it heads the first page.
            setPage(1);
            setView({ kind: "detail", id });
          }}
        />
      )}
    </Dialog>
  );
};

export default TicketsDialog;
